/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store/index";
import { getAllBankAccounts } from "@/requests/bankAccounts";
import { BankAccount } from "@/models/api/administration/bankAccounts/BankAccountsList";

export interface BankAccountsStateInterface {
  allBankAccounts: null | BankAccount[];
}

export const BankAccountsState: BankAccountsStateInterface = {
  allBankAccounts: null,
};

const BankAccountsModule = defineModule({
  state: BankAccountsState as BankAccountsStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setAllBankAccounts(state, param: null | BankAccount[]) {
      state.allBankAccounts = param;
    },
  },
  actions: {
    async getAllBankAccounts(context): Promise<BankAccount[]> {
      const { commit, state } = _moduleActionContext(context);
      if (state.allBankAccounts === null) {
        commit.setAllBankAccounts(await getAllBankAccounts());
      }
      return state.allBankAccounts as [];
    },
  },
});

export default BankAccountsModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, BankAccountsModule);
const _moduleActionContext = (context: any) => moduleActionContext(context, BankAccountsModule);
